import { SR_API_ACTION_USER_GET_PAYMENT_ACCOUNTS } from 'api/actionTypes';

export default async function getPaymentAccountsByUserId(
  { state, apiClient },
  { userId, refresh },
) {
  const statePath = ['paymentAccounts', 'byUserId', userId];
  if (state.get(statePath) && !refresh) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_USER_GET_PAYMENT_ACCOUNTS,
    state: state,
    payload: {
      userId: userId,
    },
    onSuccess(paymentAccounts) {
      state.set(statePath, paymentAccounts);
    },
  });
}
